/** 清理 Element UI 弹层关闭后残留的 .v-modal，避免挡住后续确认框 */

function isDisplayed(el) {
	if (!el) return false
	if (el.style && el.style.display === 'none') return false
	const cs = window.getComputedStyle(el)
	return cs.display !== 'none' && cs.visibility !== 'hidden'
}

export function hasVisibleElementPopup() {
	if (typeof document === 'undefined') return false
	const nodes = document.querySelectorAll('.el-dialog__wrapper, .el-message-box__wrapper, .el-drawer__wrapper')
	for (let i = 0; i < nodes.length; i++) {
		if (isDisplayed(nodes[i])) return true
	}
	return false
}

export function stripElementModals() {
	if (typeof document === 'undefined') return
	const modals = document.querySelectorAll('body > .v-modal')
	for (let i = 0; i < modals.length; i++) {
		const el = modals[i]
		if (el && el.parentNode) el.parentNode.removeChild(el)
	}
	document.body.classList.remove('el-popup-parent--hidden')
	if (document.body.style.overflow === 'hidden') {
		document.body.style.overflow = ''
	}
	document.documentElement.classList.remove('qm-cart-open')
}

export function cleanupOrphanElementOverlays() {
	if (typeof document === 'undefined') return
	if (hasVisibleElementPopup()) return
	stripElementModals()
}

/** 选品/详情都已关闭时，强制收起残留 wrapper + 遮罩 */
export function forceHideQuotationDialogs() {
	if (typeof document === 'undefined') return
	const nodes = document.querySelectorAll('.cart_dialog.el-dialog__wrapper, .good_dialog.el-dialog__wrapper')
	for (let i = 0; i < nodes.length; i++) {
		nodes[i].style.display = 'none'
	}
	stripElementModals()
}
